import type { ThreadDocumentItem } from '../config';

/**
 * Inserts or replaces the card for one document in a thread item list.
 *
 * Cards are keyed on the document, not on the artifact: a create followed by
 * a publish/update of the same document inside one run must collapse into a
 * single card reflecting the latest state instead of two duplicate cards.
 */
export const upsertThreadDocument = <I extends { type: string }>(
  items: I[],
  nextItem: I & ThreadDocumentItem,
): I[] => {
  const existingIndex = items.findIndex(
    (item) =>
      item.type === 'document' &&
      'documentID' in item &&
      item.documentID === nextItem.documentID,
  );
  if (existingIndex < 0) {
    return [...items, nextItem];
  }
  return items.map((item, index) =>
    index === existingIndex ? nextItem : item,
  );
};
